import { Component, Input, Output, EventEmitter,SimpleChanges } from '@angular/core';
import { Pagination } from '../../../services/pagination.service';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent {
  @Input() pageIndex:number=0;
  @Input() totalItemCount:number=0;
  @Input() pageCount:number=0;
  @Input() pageSize:number=0;
  @Input() tableSource = null;
  @Input() showChangePageSize:boolean=false;
  public  pages:any=[];
  @Output() renderPagination= new EventEmitter<any>();
  @Output() changePageSize= new EventEmitter<any>();
  public paginationText:string;

  constructor() { }

  ngOnInit(){
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes.tableSource &&  changes.tableSource.currentValue.pageSize) {
      this.pageSize = changes.tableSource.currentValue.pageSize;
    }
    if(changes.pageIndex && changes.pageIndex.currentValue!=changes.pageIndex.previousValue){
      this.pageIndex=changes.pageIndex.currentValue;
    }
    if(changes.pageCount && changes.pageCount.currentValue!=changes.pageCount.previousValue){
      this.pageCount=changes.pageCount.currentValue;
    }
    if(changes.pageSize && changes.pageSize.currentValue!=changes.pageSize.previousValue){
      this.pageSize=changes.pageSize.currentValue;
    }

    if(changes.totalItemCount && changes.totalItemCount.currentValue!=changes.totalItemCount.previousValue){
        this.totalItemCount=changes.totalItemCount.currentValue;
    }
    this.setPagesArr();
    this.setPaginationText();
  }
 
  onPageSizeModelChange(event){
    if(typeof this.pageSize == "number"){
      if(this.pageSize>this.totalItemCount){
        this.pageSize=this.totalItemCount;
      }
      this.changePageSize.emit({action:'first', pageno:0, pageSize:this.pageSize});
      }
  }

  setPagesArr(){
    if(this.pageSize>this.totalItemCount){
      this.pageSize=this.totalItemCount;
    }
    if(this.totalItemCount>0){
      let startPage: number, endPage: number;
      let totalPages = this.pageCount;
      let currentPage = (this.pageIndex) + 1;
      if (totalPages <= 10) {
        // less than 10 total pages so show all
        startPage = 1;
        endPage = totalPages;
      } else {
        // more than 10 total pages so calculate start and end pages
        if (currentPage <= 6) {
          startPage = 1;
          endPage = 10;
        } else if (currentPage + 4 >= totalPages) {
          startPage = totalPages - 9;
          endPage = totalPages;
        } else {
          startPage = currentPage - 5;
          endPage = currentPage + 4;
        }
      }

      // create an array of pages to ng-repeat in the pager control
      this.pages = Array.from(Array((endPage + 1) - startPage).keys()).map(i => startPage + i);
    }else{
      this.pages = [];
    }
  }
  setPaginationText(){
    if (this.totalItemCount==0) {
      this.paginationText= '';
    }else{
      const data = (this.pageSize * this.pageIndex) + 1;
      let data2 = this.pageSize * (this.pageIndex + 1);
      if(data2>this.totalItemCount){
        data2=this.totalItemCount;
      }
      this.paginationText= `Showing ${data} - ${data2} of ${this.totalItemCount}`;
    }
  }


  setPagination(action, page) {
    this.renderPagination.emit({action:action, pageno:page, pageSize:this.pageSize});
  }
}
